import { createBehaviorFlowExecutionState } from "./runBehaviorFlows.js";
import type { BehaviorFlowExecutionState, RuntimeContext } from "./types.js";

/**
 * Resolves the behavior flow state key for a layout node evaluation.
 */
export function resolveBehaviorFlowStateKey(
  nodeId: string,
  ctx: RuntimeContext,
): string {
  if (ctx.__nodeInstanceKeyPrefix) {
    return `${ctx.__nodeInstanceKeyPrefix}${nodeId}`;
  }

  if (ctx.__nodeInstanceKey) {
    return `${ctx.__nodeInstanceKey}:${nodeId}`;
  }

  return nodeId;
}

/**
 * Returns per-instance flow execution state, creating it on first use.
 */
export function getOrCreateBehaviorFlowState(
  ctx: RuntimeContext,
  stateKey: string,
): BehaviorFlowExecutionState {
  let map = ctx.__flowStateByNodeKey;

  if (!map) {
    map = new Map();
    ctx.__flowStateByNodeKey = map;
  }

  let state = map.get(stateKey);

  if (!state) {
    state = createBehaviorFlowExecutionState();
    map.set(stateKey, state);
  }

  return state;
}
